import React, { useEffect, useState } from "react";
import FormComponent from "../../../../../components/gernerateForm/FormComponent";
import generateForm08 from "../data/form08.data";

type Props = {
  onSubmit?: (value: any) => void;
  isValidateForm: boolean;
  data: any;
  setData: (value: any) => void;
  mainInputValue: any;
  isValudateFile: boolean;
  isCanEdit?: boolean | true;
};

interface WorkPermitPeriod {
  period_date: string[];
  description: string;
  ref_date: string;
}

const Form08: React.FC<Props> = (props: Props) => {
  const {
    onSubmit,
    isValidateForm,
    data,
    setData,
    mainInputValue,
    isValudateFile,
    isCanEdit,
  } = props;

  const [inputValueFormLeave08, setInputValueFormLeave08] = useState({
    information: {
      title_en: "",
      first_name_en: "",
      last_name_en: "",
      buddhist_name_en: "",
    },
    operational_data: {
      organization: "",
      country: "",
      position: "",
      level: "",
      since_date: "",
      work_permit_amonth: 1,
      time_work_permit: [],
      total_consecutive_period_year: 0,
      total_consecutive_period_month: 0,
    },
    current_contact_address: {
      house_no: "",
      street: "",
      country: "",
      province: "",
      district: "",
      district_sub: "",
      village: "",
      postcode: "",
    },
    info_about_religious_continued: {
      organization_requesting_work: "",
      position: "",
      level: "",
      start_date: "",
      end_date: "",
    },
    remuneration_info: {
      saraly_rate: "",
      accommodation_costs: "",
      transportation_costs: "",
      other: "",
      is_check_saraly_rate: false,
      is_check_accommodation_costs: false,
      is_check_transportation_costs: false,
      is_check_other: false,
    },
    reason: {
      reasons_necessity_continue: "",
      benefit_university_receive: "",
    },
  });
  const [inputPeriod, setInputPeriod] = useState<WorkPermitPeriod[]>([
    { period_date: [], description: "", ref_date: "" },
  ]);

  useEffect(() => {
    const information = mainInputValue.information;
    const condition = inputValueFormLeave08.information;
    const operational_data = {
      ...inputValueFormLeave08.operational_data,
      time_work_permit: inputPeriod,
    };
    const current_contact_address =
      inputValueFormLeave08.current_contact_address;
    const info_about_religious_continued =
      inputValueFormLeave08.info_about_religious_continued;
    const remuneration_info = inputValueFormLeave08.remuneration_info;
    const reason = inputValueFormLeave08.reason;

    setData({
      main: information,
      condition: condition,
      operational_data: operational_data,
      current_contact_address: current_contact_address,
      info_about_religious_continued: info_about_religious_continued,
      remuneration_info: remuneration_info,
      reason: reason,
    });
  }, [inputValueFormLeave08]);

  useEffect(() => {
    if (data) {
      setInputValueFormLeave08({
        information: data.condition ?? inputValueFormLeave08.information,
        operational_data:
          data.operational_data ?? inputValueFormLeave08.operational_data,
        current_contact_address:
          data.current_contact_address ??
          inputValueFormLeave08.current_contact_address,
        info_about_religious_continued:
          data.info_about_religious_continued ??
          inputValueFormLeave08.info_about_religious_continued,
        remuneration_info:
          data.remuneration_info ?? inputValueFormLeave08.remuneration_info,
        reason: data.reason ?? inputValueFormLeave08.reason,
      });
      setInputPeriod(data.operational_data.time_work_permit ?? []);
    }
  }, []);

  console.log("inputValueFormLeave08", inputValueFormLeave08);

  return (
    <div
    // onClick={() => {
    //   onSubmit("text");
    // }}
    >
      <FormComponent
        formGenerate={generateForm08}
        inputValue={inputValueFormLeave08}
        setInputValue={setInputValueFormLeave08}
        handleCheckValid={isValidateForm}
        isCanEdit={isCanEdit ?? true}
        permission={"admin"}
        setInputPeriod={setInputPeriod}
      />
    </div>
  );
};

export default Form08;
